/* istanbul ignore file */
export enum WafPrefix {
    Hyperlink = 'urlLink-',
    RichText = 'richText-',
    HyperlinkSearch = 'urlLink',
    RichTextSearch = 'richText'
}
